import { AxiosError } from "axios";
import { getApi, patchApi, postApi, putApi } from "../CreateApi";
import { ResponseGetAllDebt, ResponseGetReportPayments } from "./interfaceTreasury";

export const getTreasuryStudent = async (student: number, params?: any): Promise<ResponseGetAllDebt> => {
    try {
        const data = await getApi(`/treasury/debts/${student}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const getTreasuryStudentNoDefeated = async (student: number): Promise<ResponseGetAllDebt> => {
    try {
        const data = await getApi(`/treasury/debts/${student}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const postTreasuryStudent = async (debtId: number, body: { paymentMethod: number, parentId: number }): Promise<any> => {
    try {
        const data = await postApi(`/treasury/payment/${debtId}`, {...body, parentId: Number(body.parentId) });
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}


export const getTreasuryPayment = async (body: any): Promise<ResponseGetReportPayments> => {
    try {
        const data = await getApi(`/treasury/payment`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}


export const getTreasuryGenerateTxt = async (type: string): Promise<ResponseGetReportPayments> => {
    try {
        const data = await getApi(`/treasury/generate-txt/${type}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const postTreasuryProcessTxtBank = async (body: any, bank: string): Promise<any> => {
    try {
        const data = await postApi(`/treasury/process-txt/${bank}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}


export const postGenerateDiscount = async (body: any, id: number): Promise<any> => {
    try {
        const data = await postApi(`/treasury/discount/${id}`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}


export const putGenerateDiscount = async (body: any, id: number): Promise<any> => {
    try {
        const data = await patchApi(`/treasury/${id}/discount`, body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}



export const getTreasuryDetailsStudent = async (id: string, yearId: string): Promise<any> => {

    let params = {yearId : yearId}; 

    try {
        const data = await getApi(`/treasury/${id}/report-payments`, params);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}



export const getTreasuryDebortsReportMonth = async (params: any): Promise<any> => {
    try {
        const data = await getApi(`/treasury/debtors-report-by-month`,  params);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const getTreasuryStatus = async (jodId?: string): Promise<any> => {
    try {
        const data = await getApi(`/treasury/status`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const getStatusTreasury = async (jobId: string): Promise<any> => {
    try {
        const data = await getApi(`/treasury/status/${jobId}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}